import { activityFeed } from "@/pages/admin/dashboard/dashboardData";

const BUBBLE: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-900",
  secondary: "bg-secondary-100 text-secondary-700",
};

const DOT: Record<string, string> = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-500",
};

export default function ActivityTimeline() {
  return (
    <section className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
      <div className="flex items-center justify-between gap-3">
        <h2 className="font-heading text-xl text-foreground-950 font-semibold">Recent activity</h2>
        <span className="text-xs text-foreground-500">Live operations feed</span>
      </div>

      <ol className="mt-5 relative">
        <span className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200" aria-hidden="true"></span>
        {activityFeed.map((entry) => (
          <li key={entry.title} className="relative flex items-start gap-4 pb-5 last:pb-0">
            <span
              className={`relative z-10 w-10 h-10 flex items-center justify-center rounded-full shrink-0 ring-4 ring-background-50 ${BUBBLE[entry.tone]}`}
            >
              <i className={`${entry.icon} text-base`}></i>
              <span
                className={`absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full ring-2 ring-background-50 ${DOT[entry.tone]}`}
              ></span>
            </span>
            <div className="min-w-0 flex-1 pt-1">
              <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-0.5">
                <p className="text-sm font-semibold text-foreground-950">{entry.title}</p>
                <span className="text-[11px] text-foreground-400 whitespace-nowrap">{entry.time}</span>
              </div>
              <p className="text-xs text-foreground-600 mt-0.5">{entry.sub}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}